<div class="lmo-orders">
  <mat-tab-group mat-stretch-tabs [selectedIndex]="selectedIndex$ | async">
    <mat-tab label="Pending"><sa-lmo-orders-pending></sa-lmo-orders-pending></mat-tab>
    <mat-tab label="In Progress"><sa-lmo-orders-in-progress></sa-lmo-orders-in-progress></mat-tab>
    <mat-tab label="Completed"><sa-lmo-orders-completed></sa-lmo-orders-completed></mat-tab>
  </mat-tab-group>
  <a mat-raised-button color="primary" class="new-order-button" [routerLink]="['order', 'new']"
    ><mat-icon>edit</mat-icon>Order</a
  >
</div>
